import React from 'react'
import { Star, StarBorder } from '@mui/icons-material'
import styles from './WatchlistButton.module.scss'

export default function WatchlistButton({ active, handleClick, value, externalClassName }) {
    const onClick = () => handleClick(value.uuid)

    return (
        <button className={externalClassName} onClick={onClick}>{active ? <Star color='watchList'/> : <StarBorder classes={{root: styles['star-border']}}/>}</button>
    )
}